import { render, staticRenderFns } from "./HazardTypeEdit.vue?vue&type=template&id=c57d1be0"
import script from "./HazardTypeEdit.vue?vue&type=script&lang=js"
export * from "./HazardTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports